import Cookies from 'js-cookie';

class CookieService {
  static setCookie(name:string, value:string, options = {}) {
    Cookies.set(name, value, {...options});
  }
  static getCookie(name:string) {
    return Cookies.get(name);
  }
  static removeCookie(name:string) {
    Cookies.remove(name);
  }
  static hasCookie(name:string) {
    return !!Cookies.get(name);
  }
}

export default CookieService;
